
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Tai pristato
                    <a href="${0}">„Folksonomy Engine“ projektas</a>. Nedvejokite
                    dalyvauti arba pateikti atsiliepimų.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Šis įrankis leidžia pataisyti sudedamųjų dalių sąrašą. Galite pridėti, pašalinti arba redaguoti
                ingredientų sąrašą.
                <br>
                Šis simbolis <span class="highlight">␣</span> reiškia tarpą.
                <br>
                Šis simbolis <span class="highlight">↩︎</span> reiškia eilutės lūžį. `,
'hb28f1f2ec1744ee9': html`Šias savybes kuria ir pateikia vartotojai bet kokiam naudojimui. Galite
                    pridėti savo. Jūsų sukurtos savybės ir reikšmės
                    <strong>turi būti faktinės</strong>. Galite pasinerti į
                    <a href="${0}">bendruomenės jau naudojamų savybių sąrašą</a>
                    arba peržiūrėti savybių
                    <a href="${1}">dokumentaciją ir jos paieškos sistemą</a>.`,
's000a5b76bd3a01c2': `Įkeliamos savybės...`,
's000d98595e959c1e': `Atsisiųsti per Google Play`,
's013bdc8cf0d3583d': `Padėkite mums dėl ingredientų`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Patvirtinti pasėlį`,
's03e9c8114521b998': `Aš redaguosiu ingredientus`,
's05ec315d9308091a': `Brūkšninio kodo kampų piktograma`,
's061eb5af92512c85': `Išsaugota! Gal galite padėti su kita?`,
's06847c221c4c0bc1': `Norėčiau sukurti savybę, skirtą [aprašyti savo naudojimo atvejį]...`,
's06f6c6f99db6b552': `Originalus`,
's081e2ad82db71e1d': `Sugrupuotos vertės`,
's09205907b5b56cda': `Ne`,
's0b4235aae602a950': `speciali dokumentacija`,
's0bb2d48532acc455': `Atsisiųsti CSV failą`,
's0d5b7fee0311db68': `Savybė`,
's0fb218abc2e157ed': `Anuliuoti nuotrauką`,
's100c4928cc74642a': `paremti visuomenės sveikatos tyrimų pažangą.`,
's10db5498186c083b': `Atšaukti apkarpymą`,
's11a18a69b30b65ed': `Padėkite mums ištaisyti sudedamųjų dalių sąrašo klaidas`,
's1205d5f6fccf8e69': `Turto vertė`,
's15d64a0a6715285a': `Naujas raktas`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Pasirinkimo sritis`,
's1a52515ec8ddade8': `Brūkšninis produkto kodas`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Padėkite mums pakoreguoti informaciją apie maistinę vertę`,
's1e00019dc454872d': `Prašome pateikti ypatybės pavadinimą naudojant „property-name“ atributą.`,
's1e49126af0935a5b': `Šią savybę naudojančių produktų sąrašas`,
's21e73088de6f26f3': `Atsisiųskite iš App Store`,
's255857544a9d5ec0': `Atstatyti`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Atšaukti`,
's2db7b654c0a9bde0': `Dokumentuokite turtą`,
's300b3a6ee4e1252d': str`Prastas atitikimas ${0}%`,
's33f786bb6b4f0cf4': `Apkarpymo rezultatas`,
's33f85f24c0f5f008': `Išsaugoti`,
's34be4af4e8fec4ae': `Pirmiausia paklauskite bendruomenės`,
's36d86adc823cbfa6': `Prieš kurdami naują savybę, aptarkite ją su bendruomene:`,
's3781d25aa51a736c': `Folksonomy variklio dokumentacija`,
's383ae4449428b61e': `Atstatyti apkarpymą`,
's39bcf88721a1e8ee': `Atkurti pasirinkimą`,
's39e14e14300694c7': `Dokumentacija ir gairės`,
's3b430cfa5c1fe7f4': str`Dokumentacija, skirta ${0}`,
's3f4e4b52f230a892': `Vaizdo drobė`,
's417b90913e05bc17': `Peržiūra`,
's41f7dca46d3f1b4a': `Vertė`,
's422bba9636ce2489': `Centruoti nuotrauką`,
's42dd66b2441566fd': `Centruoti piktogramą`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Pridėti maistinę medžiagą`,
's453ab0dbb9b5c777': `Keisti dydį dešinėje`,
's475b08749d0706ed': `Padėkite mums informuoti milijonus vartotojų visame pasaulyje apie tai, ką jie valgo`,
's49730f3d5751a433': `Įkeliama...`,
's4bbc7472834a9686': `Jūsų naršyklė nepalaiko brūkšninio kodo nuskaitymo.`,
's4d42cc7e00076a3b': `Produktų skaičius`,
's4df2f533c0c1e7d0': `Vaizdo valdikliai`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Perkelti pasirinkimą`,
's4f751fb9b3ed766c': `Naujos savybės kūrimas`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Įveskite objekto pavadinimą...`,
's55d7249883a98ca1': `apie šį objektą „Open Food Facts“ wiki puslapyje`,
's565867d84c04aea2': `Filtro ypatybės...`,
's5666afe5cd0166de': `Prieš patvirtindami, ištaisykite klaidas arba pakeiskite tekstą`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Įkeliami produktai...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Padėkite mums ištaisyti informaciją apie maistinę vertę.`,
's5dd6f12783fca34f': `Redaguoti sudedamųjų dalių sąrašą`,
's5e8250fb85d64c23': `Uždaryti`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `AŠ REMIU`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Redaguoti`,
's66413c24dcf680e2': `Praleisti`,
's67ae6594857a4d57': `Ačiū už jūsų indėlį!`,
's6cee7cad81dfedd1': `Apkirptas vaizdas`,
's6d7b6cdedaadfb6e': `Kiekviena auka svarbi! Dėkojame už jūsų paramą didinant maisto skaidrumą pasaulyje.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Geras atitikimas ${0}%`,
's71a5c9f4b68ef4d4': `Kiekis`,
's74cb3d66f6a668e1': `Dokumentacija`,
's787dd11bed0dc88a': `Keisti dydį kairėje`,
's7ce4fd9430e80cea': `vertė`,
's801a05fa8e881f37': `Sužinokite daugiau apie nuosavybės kūrimą ir gaires:`,
's8038273de2cf8b73': `Pasirinkite sritį atkirpti.`,
's839cc2908a5387f2': `Filtruoti brūkšninius kodus...`,
's86197dcf3e96af64': `Naršyti ir ieškoti esamų savybių`,
's8a63be30a129a59c': `Keisti apačios dydį`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Keisti dydį viršuje dešinėje`,
's8db84aa4bc949af2': `Dokumentuokite naują turtą`,
's8f839a03997a16d7': `Peržiūrėti produktą`,
's901ae1e236ac45d3': `Atšaukti trynimą`,
's907f7a97c6b29425': `Įsidėmėkite, kad duomenų modelį galima modifikuoti. Naudokite savo pačių rizika.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Spustelėkite, kad nuskaitytumėte brūkšninį kodą ir sužinotumėte jo informaciją (sveikatą, nuostatas ir kt.)`,
's98ff35f2a00dc60d': `Sudedamosios dalys:`,
's9a7f60fce090ecaf': `Nepavyko įkelti ypatybių. Bandykite dar kartą vėliau.`,
's9b87abd68fb9df45': `Nerandate? Sukurkite naują raktą {value}`,
's9c0f52425fd2f07e': `Gali neatitikti`,
's9fc41f789c63b40d': `Produktai`,
'sa1fa766e0d5634d7': `Nėra balų`,
'sa548778b24054030': `Naršykite visas „Folksonomy Engine“ projekto sukurtas ypatybes. Šios ypatybės suteikia papildomų metaduomenų ir įžvalgų apie produktus „Open Food Facts“ duomenų bazėje.`,
'sa63907958bd0ec4b': `Keisti dydį viršuje kairėje`,
'sa95b4224f685a36a': `Uždaryti modalinį langą`,
'sab56a1d439576fd6': `Pasiūlymo piktograma`,
'sac47ea2901d04c15': `Keisti dydį apačioje kairėje`,
'sb125227d436c2925': `Ieškokite savo savybės koncepcijos esamoje savybių duomenų bazėje:`,
'sb125568d43642e6f': `Atsakykite į klausimus apie produktą.`,
'sb1c538e038f9b214': str`Labai geras atitikimas ${0}%`,
'sb28639570ff3b852': `visų objektų sąrašas`,
'sb3bdd638a58d30f4': `suburti atsidavusių piliečių bendruomenę,`,
'sb3cbcc1bd0fff140': `Kai patvirtinsite, kad jūsų nuosavybė neegzistuoja, ir bendruomenė sutinka, kad ji naudinga, pirmiausia turėsite ją užfiksuoti wiki.`,
'sb3d4f79d9d8b71e5': `Pateikti`,
'sb560fa37a7bfb6c2': `Šiai nuosavybei nerasta jokių produktų.`,
'sb7f72e4c8a2d3357': `Filtruoti reikšmes...`,
'sb8178320160f84ea': `Rodyti apkarpymą`,
'sbad7d2734149470b': `Patvirtinti`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Į visas įžvalgas atsakyta! Ačiū už pagalbą!`,
'sbd9a0b2293b3cd3c': `Porcijos dydis`,
'sbe472dc3c2685985': `Atitinkama vertė`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Keisti dydį viršuje`,
'sc1c08d0cbcc3bd24': `Neatitinka`,
'sc52696641af72b53': `Atsisiųskite programėlę!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Siūlomas pataisa`,
'sc681b137e8f604f7': `Patvirtinti ištrynimą`,
'sc6daf8a31883f8b9': `Perkelti vaizdą`,
'sc895972c88d38ca5': `Folksonomijos nuosavybė`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Eilutės`,
'scb3b0671d7b7f640': `Nauja vertė`,
'scb489a1a173ac3f0': `Taip`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Prisijungti prie „Slack“ diskusijos`,
'scdb6cad0b92721bf': `Nerasta jokių savybių.`,
'scf23a05631f93732': `Patvirtinti trynimą`,
'scfed2f270ef6a3aa': `Pasirinkite sritį`,
'sd1022bc1ef9204f7': `Keičiamo mastelio vaizdas`,
'sd1077c055cf9ba6b': `Padėkite mums patvirtinti produkto sudedamųjų dalių sąrašą.`,
'sd698d21ddecba56b': `Sveiki! Jūs galite padėti mums pagerinti produkto informaciją atsakydami į tolesnius klausimus:`,
'sd82bc2decefa621b': `padeda išlikti nepriklausomais nuo maisto pramonės,`,
'sdb97e5976482606e': `Patikrinkite, ar savybė jau yra`,
'sdbf806fefc584115': `Turėtumėte rasti`,
'sdc673e73b5c13aea': `Ištrinti`,
'sdc792b75f1edcaba': `Padėkite mums ištaisyti ingredientų rašybą.`,
'sdca5deead576ceee': `Keisti dydį apačioje dešinėje`,
'sdcc2555c5dde524f': `Ar tikrai norite ištrinti šią prekę? Šio veiksmo negalima atšaukti.`,
'se206feec7ec57b28': `už 100 g`,
'se419a9ab36987490': `Pripažinti negaliojančiu`,
'se5127cf0f92e7e48': `Patarimas: taip pat galite rasti`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Aš siūlysiu geresnį derlių`,
'seea3800e27baa686': `Individualūs produktai`,
'sefaba4adc4ec9219': `Folksonomijos ypatybės`,
'seffa8ca49175b5f0': `Suasmenintos savybės`,
'sf44a6b3b232c28ea': str`Pakeisti esamą vertę į ${0}`,
'sf4cd86a2f5ef2588': `Produkto brūkšninis kodas`,
'sf57a61152168cc81': `Padėkite mums pakoreguoti sudedamųjų dalių nustatymą`,
'sf88b90b8ba23871c': `Nežinoma atitiktis`,
'sf9aee319a006c9b4': `Pridėti`,
'sfacbbe968fa7d773': `Nuosavybės pavadinimas:`,
'sfc40ea3d5d5aa6f8': `Jūsų aukos finansuoja kasdienę mūsų ne pelno asociacijos veiklą:`,
'sfe87465d50530725': `Atitinkama vertė`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  